import { useLayoutEffect } from "react";
import { useLocation } from "react-router";
import { useChatStore } from "@/stores/useChatStore";
import { mainViewFromPathname, useLayoutStore } from "@/stores/useLayoutStore";

/**
 * URL パスとサイドバーで選択中のメインビュー (`useLayoutStore.mainView`) を同期する。
 *
 * - URL が変わったら (リロード・ディープリンク・戻る/進む) パスからビューを復元する。
 * - サイドバーからの切り替えは各ボタンが URL を遷移させ、その結果ここで store に反映される。
 *
 * 何も描画しない。`ChatUrlSync` と同じく AppLayout 内にマウントする。
 */
export function MainViewUrlSync() {
	const { pathname } = useLocation();
	const setMainView = useLayoutStore((s) => s.setMainView);
	const setNewChatEnvironmentStatusValidating = useChatStore(
		(s) => s.setNewChatEnvironmentStatusValidating,
	);

	useLayoutEffect(() => {
		const mainView = mainViewFromPathname(pathname);
		if (mainView === "chats" && useLayoutStore.getState().mainView !== "chats") {
			// 他のビューからチャットへ戻る前に状態確認中へ切り替え、古い検証済み状態のまま
			// 送信できる描画を防ぐ。この遷移では `mainView` の変化でセレクタの読み込みが
			// 再実行され、完了時に false へ戻る。チャット内の URL 変化 (`/` → `/chats/new` 等)
			// では読み込みが再実行されないため、ここでフラグを立てると戻らなくなる。
			setNewChatEnvironmentStatusValidating(true);
		}
		setMainView(mainView);
	}, [pathname, setMainView, setNewChatEnvironmentStatusValidating]);

	return null;
}
